import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { GUARANTEE } from './salesData';

/** GARANTÍA. Única sección de garantía de la página. */
export function GuaranteeSection() {
  return <section className="bg-cream py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-199" data-mp="9ttkmm638j3x">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-200" data-mp="etft6iaz1b6e">
        <div className="flex flex-col items-center gap-6 rounded-5xl border border-warm bg-ivory p-6 text-center sm:flex-row sm:gap-9 sm:p-9 sm:text-left" data-id="element-201" data-mp="euqzopvswx17">
          {/* Sello visual de 7 días. */}
          <div className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full border-2 border-dashed border-[#F47A2A] bg-caramel-pale sm:h-28 sm:w-28" aria-hidden data-id="element-202" data-mp="nsb427oyn9g1">
            <ShieldCheckIcon className="h-5 w-5 text-[#F47A2A]" data-id="element-203" data-mp="xlrvx65jeeh2" />
            <span className="mt-1 font-display text-[1.15rem] leading-none text-charcoal" data-id="element-204" data-mp="12klbd44dwfjv">
              {GUARANTEE.seal}
            </span>
            <span className="mt-0.5 font-sans text-[0.5rem] font-bold uppercase tracking-[0.14em] text-charcoal-mid" data-id="element-205" data-mp="25rxb0sta741m">
              Garantía
            </span>
          </div>

          <div data-id="element-206" data-mp="20ux2mb8ylp7c">
            <h2 id="guarantee-title" className="font-display text-[1.4rem] leading-tight text-charcoal sm:text-[1.9rem]" data-id="element-207" data-mp="1vtr94b7h5xwr">
              {GUARANTEE.title}
            </h2>
            <p className="mt-3 font-sans text-[0.9rem] leading-relaxed text-charcoal-mid" data-id="element-208" data-mp="2oi59gxm1d6bh">
              {GUARANTEE.body}
            </p>
          </div>
        </div>
      </div>
    </section>;
}